import React from 'react';

const Services = () => {
  return (
    <section className="py-5 bg-dark text-white" id="services">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center mb-5">
            <span className="badge bg-primary bg-opacity-20 text-primary px-3 py-2 rounded-pill mb-3">
              🚀 Our Services
            </span>
            <h2 className="display-5 fw-bold text-white mb-4">Explore Our Top Services</h2>
            <p className="lead text-light mb-0">
              At MastiShorts, we go beyond just live streaming — we empower creators to engage, earn, and entertain with powerful tools and exciting experiences tailored for the digital age.
            </p>
          </div>
        </div>
        
        <div className="row g-4">
          <div className="col-lg-3 col-md-6">
            <div className="card bg-dark border border-primary border-opacity-25 h-100 rounded-4 overflow-hidden position-relative hover-lift">
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-primary opacity-5"></div>
              <div className="card-body text-center p-4 position-relative">
                <div className="bg-primary bg-gradient text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 shadow" style={{width: '80px', height: '80px'}}>
                  <i className="fas fa-video fa-2x"></i>
                </div>
                <h4 className="fw-bold mb-3 text-white">Live Streaming</h4>
                <p className="text-light mb-4">
                  Go live and engage your fans in real time. Host interactive sessions, invite guests, and receive virtual gifts while building your personal brand on the go.
                </p>
                <button className="btn btn-outline-primary btn-sm rounded-pill px-4 py-2">
                  Learn More <i className="fas fa-arrow-right ms-1"></i>
                </button>
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-6">
            <div className="card bg-dark border border-success border-opacity-25 h-100 rounded-4 overflow-hidden position-relative hover-lift">
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-success opacity-5"></div>
              <div className="card-body text-center p-4 position-relative">
                <div className="bg-success bg-gradient text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 shadow" style={{width: '80px', height: '80px'}}>
                  <i className="fas fa-play-circle fa-2x"></i>
                </div>
                <h4 className="fw-bold mb-3 text-white">Short Video Creation</h4>
                <p className="text-light mb-4">
                  Create eye-catching, fun videos anytime. With trending sounds, filters, and effects, making viral content has never been this easy.
                </p>
                <button className="btn btn-outline-success btn-sm rounded-pill px-4 py-2">
                  Learn More <i className="fas fa-arrow-right ms-1"></i>
                </button>
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-6">
            <div className="card bg-dark border border-warning border-opacity-25 h-100 rounded-4 overflow-hidden position-relative hover-lift">
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-warning opacity-5"></div>
              <div className="card-body text-center p-4 position-relative">
                <div className="bg-warning bg-gradient text-dark rounded-circle d-inline-flex align-items-center justify-content-center mb-4 shadow" style={{width: '80px', height: '80px'}}>
                  <i className="fas fa-gift fa-2x"></i>
                </div>
                <h4 className="fw-bold mb-3 text-white">Gifting & Rewards</h4>
                <p className="text-light mb-4">
                  Earn while you entertain. Receive virtual gifts from fans, unlock special achievements, and turn your talent into income.
                </p>
                <button className="btn btn-outline-warning btn-sm rounded-pill px-4 py-2">
                  Learn More <i className="fas fa-arrow-right ms-1"></i>
                </button>
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-6">
            <div className="card bg-dark border border-info border-opacity-25 h-100 rounded-4 overflow-hidden position-relative hover-lift">
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-info opacity-5"></div>
              <div className="card-body text-center p-4 position-relative">
                <div className="bg-info bg-gradient text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 shadow" style={{width: '80px', height: '80px'}}>
                  <i className="fas fa-trophy fa-2x"></i>
                </div>
                <h4 className="fw-bold mb-3 text-white">PK Battles</h4>
                <p className="text-light mb-4">
                  Challenge other streamers in exciting live battles. Compete in real-time, gain rankings, win gifts, and keep your audience hooked with thrilling PK matchups.
                </p>
                <button className="btn btn-outline-info btn-sm rounded-pill px-4 py-2">
                  Learn More <i className="fas fa-arrow-right ms-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
